import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { computed } from 'vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'buttonCustom',
  props: {
    title: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  const props = __props;

  const isDisabled = computed(() => props.disable || props.loading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    disabled: isDisabled.value,
    class: _normalizeClass([{
      'bg-gray-800': isDisabled.value,
    }, "w-full py-3 flex items-center justify-center bg-teal-950 text-white text-center text-lg font-medium rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600"])
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[1] || (_cache[1] = [
          _createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1),
          _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8v8H4z"
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.loading ? 'Loading...' : __props.title), 1)
  ], 10, _hoisted_1))
}
}

})